import { getMemberShipLogListForFeeService } from '@/helpers/service/api/report'
import { json2csv_fn, toThousands } from "@/utils/common";
import locale from "@/helpers/locale";
import moment from "moment";
import { weekLocaleArray } from "@/utils/common";

function displayDeviceName(row) {
  if (!row) {
    return ''
  }
  const {
    platform,
    name,
    deviceName,
  } = row
  if (platform && platform === 'Pos') {
    const stringArr = []
    if (deviceName) stringArr.push(deviceName)
    if (name) stringArr.push(name)
    return stringArr.join('/')
  } else {
    const stringArr = []
    if (platform) stringArr.push(platform)
    if (name) stringArr.push(name)
    return stringArr.join('/')
  }
}
export function exportCSV_fn(requestParma, cinemaList) {
  console.log('list', cinemaList)
  getMemberShipLogListForFeeService(requestParma).then(res => {
    if (res.data && res.success && res.data.data.length > 0) {
      console.log(res.data.data)
      let csvData = []
      const fields = [
        {
          label: locale("trans.koisk.transid"),
          value: 'transactionId'
        },
        {
          label: locale("dailyClosing.th.dayCloseDate"),
          value: 'createTime'
        },
        {
          label: locale("trans.other.memberId"),
          value: 'memberNum'
        },
        {
          label: locale("report.memberShip.memberType"),
          value: 'memberShipName'
        },
        {
          label: locale("report.memberShip.createUpdate"),
          value: 'joinType'
        },
        {
          label: locale("trans.other.price"),
          value: 'cost'
        },
        {
          label: locale("global.cinemaName"),
          value: 'cinemaName'
        },
        {
          label: locale("inventoryLog.changePeople"),
          value: 'changePeople'
        }
      ]
      res.data.data.forEach(item => {
        csvData.push({
          transactionId: item.transactionId,
          createTime: moment(item.createTime).format(`YYYY年M月DD日(${weekLocaleArray[
            moment(item.createTime).day()
          ]}) HH:mm`),
          memberNum: item.memberNum,
          memberShipName: item.memberShipName,
          joinType: item.joinType === 'join' ? '新規' : '更新',
          cost: item.cost.toLocaleString(),
          cinemaName: (cinemaList.find(cinema => cinema.id === item.cinemaId) || {}).name,
          changePeople: displayDeviceName(item.createdBy)
        })
      })
      json2csv_fn(csvData, fields, moment().format("YYYYMMDDHHmm") + "_" + locale("sideMenu.reports.CLTransaction"))
    }
  })
}